import React from 'react'
import { useNavigate } from "react-router-dom";

const GoBack = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        const idx = window.history.state?.idx;

        if (idx > 0) {
        navigate(-1);       // volver
        } else {
        navigate("/GanaConMastercardDebit");      // ir al inicio
        }
    };

    return (
        <>
            <div className='GoBack'>
                <button onClick={handleGoBack} className='btn btn-goback' >
                    <img src="/assets/images/undo.png" alt="icono de volver atrás" />
                    Volver a la página anterior
                </button>                
            </div>
        </>
    )
}

export default GoBack
